// extracted by mini-css-extract-plugin
export default {"productSponsorLabel":"CubfZ"};